/**
 * Accessibility constants shared by hand-styled screens.
 *
 * The admin screens style with inline `style` objects rather than
 * utilities, so values that carry a rule behind them — rather than a designer's
 * choice — live here where the rule can be stated once.
 */

/**
 * Minimum width and height of a pointer target, in px (WCAG 2.5.5 Target Size).
 *
 * Controls that sit in a dense row and cannot afford it — several icon buttons
 * sharing a line with a title — should state their own smaller size at the call
 * site with a comment, not silently omit this.
 */
export const TOUCH_TARGET_MIN_PX = 44;

/**
 * Class that draws the keyboard focus ring on a container instead of the field
 * inside it, for shells whose only input is deliberately borderless (search
 * bars). Paired with `.ic-focus-shell:focus-within` in `index.css`.
 */
export const FOCUS_SHELL_CLASS = 'ic-focus-shell';
